import React from "react";
import { VariantProps, cva } from "class-variance-authority";
import { Tabs } from "./Tabs";

const tabsStyles = cva("flex flex-col", {
  variants: {
    bgColor: {
      white: "bg-white",
      primary: "bg-primary-50",
    },
  },
  defaultVariants: { bgColor: "primary" },
});

type Tab = {
  label: React.ReactNode;
  panel: React.ReactNode;
};

export interface TabsProps extends VariantProps<typeof tabsStyles> {
  startAtIndex?: number;
  tabs: Tab[];
  label: string;
  onTabClicked?: (value: string) => void;
}

export const TabContainer = ({
  startAtIndex = 0,
  tabs,
  label,
  bgColor,
  onTabClicked,
}: TabsProps) => {
  const labels = tabs.map((tab) => tab.label);
  const panels = tabs.map((tab) => tab.panel);

  return (
    <Tabs
      className={tabsStyles({ bgColor })}
      defaultValue={`${startAtIndex}`}
      onValueChange={onTabClicked}
    >
      <Tabs.List
        className="flex shrink-0 shadow-[inset_0_-1px_0_0,0_1px_0_0] shadow-primary-100"
        aria-label={label}
      >
        {labels.map((label, index) => {
          return (
            <Tabs.Trigger
              className="flex flex-1 select-none items-center justify-center border-0 bg-transparent p-5 leading-none shadow-[inset_0_-1px_0_0,0_1px_0_0] shadow-transparent outline-none transition hover:shadow-primary-300 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-opacity-75 focus-visible:ring-offset-2 data-[state=active]:font-semibold data-[state=active]:text-primary data-[state=active]:shadow-primary"
              value={`${index}`}
              key={index}
            >
              {label}
            </Tabs.Trigger>
          );
        })}
      </Tabs.List>
      {panels.map((panel, index) => {
        return (
          <Tabs.Content
            className="grow p-5 outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-opacity-75 focus-visible:ring-offset-2"
            value={`${index}`}
            key={index}
          >
            {panel}
          </Tabs.Content>
        );
      })}
    </Tabs>
  );
};
